import { useEffect } from "react";

// Um atalho de teclado, registrado por quem sabe o que ele faz.
//
// A regra de quando NÃO agir é a parte que importa e é sempre a mesma: quem
// está digitando espera que a tecla vire letra, e um modal aberto é dono do
// teclado enquanto estiver ali. Sem isso, escrever "resolver" para o cliente
// resolveria o atendimento no meio da frase.
//
// Navegar (andar na lista, buscar) é tecla solta: fora dos campos ela não tem
// o que atrapalhar, e o pior que acontece é abrir outra conversa. Já o que
// MUDA o atendimento pede Alt: entre a tecla escapar do campo por um clique
// perdido e o atendimento ser resolvido sozinho, a diferença é o dedo no Alt.
export const digitando = (alvo) =>
	alvo?.isContentEditable ||
	["INPUT", "TEXTAREA", "SELECT"].includes(alvo?.tagName);

const useAtalhoDeTeclado = (tecla, aoAcionar, ativo = true, { alt } = {}) => {
	useEffect(() => {
		if (!ativo) return undefined;

		const aoTeclar = (e) => {
			// Com Alt o macOS troca a letra por outro caractere (⌥e vira "´"),
			// então quem manda é a POSIÇÃO da tecla, não o que ela escreveu.
			const bate = alt
				? e.code === `Key${tecla.toUpperCase()}`
				: e.key === tecla;

			if (!bate) return;
			if (Boolean(e.altKey) !== Boolean(alt)) return;
			// Ctrl e Cmd pertencem ao navegador ou ao sistema.
			if (e.ctrlKey || e.metaKey) return;
			if (digitando(e.target)) return;
			if (document.querySelector("[role=dialog]")) return;

			e.preventDefault();
			aoAcionar(e);
		};

		window.addEventListener("keydown", aoTeclar);
		return () => window.removeEventListener("keydown", aoTeclar);
	}, [tecla, aoAcionar, ativo, alt]);
};

export default useAtalhoDeTeclado;
